export default {
  'account:bonus-program:description':
    'Hast du schon gewusst, dass du mit jeder Bestellung bei Pets Deli punkten kannst? Jeder ausgegebene CHF bringt dir einen Punkt auf dein Konto und zu besonderen Anlässen verdienst du dir mit tollen Aktionen weitere Punkte dazu.',

  'account:bonus-program:guide-1':
    'Mit jedem Kauf (1CHF = 1 Punkt) und mit besonderen Aktionen schreiben wir dir Punkte auf dein Pets Deli-Konto gut.',
};
